export const SPLITS_KINDS = {
  batter: {
    reportType: "Hitting Splits",
    leaderboardPath: "/leaderboards/splits",
    rosterKey: "positionPlayers",
    fileSlug: "hitting_splits",
  },
  pitcher: {
    reportType: "Pitching Splits",
    leaderboardPath: "/leaderboards/splits_pitcher",
    rosterKey: "pitchers",
    fileSlug: "pitching_splits",
  },
};
